import { BigNumber, ethers } from 'ethers';
import abi from './abi';
import { ZERO_ADDRESS } from '$lib/web3/addresses';
import { getEthersSigner } from './etherAdapters';

export async function estimateGasLimits(
	address: string,
	targetArray: Array<string>,
	encodedFunctionInputDataArray: Array<string>,
	functionName: string,
	value: ethers.BigNumber = ethers.BigNumber.from('0')
): Promise<BigNumber> {
	const synthetixContract = new ethers.Contract(address, abi.scWalletMainImpl).connect(
		(await getEthersSigner())!
	);
	let gasLimit;
	try {
		gasLimit = await synthetixContract.estimateGas[functionName](
			targetArray,
			encodedFunctionInputDataArray,
			ZERO_ADDRESS,
			{
				value
			}
		);
		return gasLimit.mul(3).div(2);
	} catch (e: any) {
		console.log(e);
		throw {
			name: 'Failed GasLimit Estimation',
			message: e,
			type: 'ethers'
		};
	}
}

export async function estimateGasLimitsRaw(
	to: string,
	data: string,
	value: bigint,
	from?: string
): Promise<bigint> {
	const ethersSigner = await getEthersSigner();
	const signerAddress = await ethersSigner?.getAddress();
	let gasLimit;
	try {
		gasLimit = await ethersSigner?.estimateGas({ from: from ?? signerAddress, to, value, data })!;
		return gasLimit.mul(3).div(2).toBigInt();
	} catch (e) {
		console.log(e);
		throw {
			name: 'Failed GasLimit Estimation',
			message: e,
			type: 'ethers'
		};
	}
}
